import { hasIntersect } from '@common/js/common'
// import snapshot from '@/page/snapshot'
import snapshot from '@/page/index'
import layout from '../layout'
import login from '@/page/index/login'
import googleLogin from '@/page/index/googleLogin'
import register from '@/page/index/register'
import userVerify from '@/page/account/userVerify'
import tokenInvalid from '@/page/account/tokenInvalid'

import campaignCreate from '@/page/campaign/campaignCreate'
import campaignCreateBrush from '@/page/campaign/campaignCreateBrush'
import campaignList from '@/page/campaign/campaignList'
import campaignBrushList from '@/page/campaign/campaignBrushList'
import deposit from '@/page/deposit/deposit'
import record from '@/page/deposit/record'
import profile from '@/page/profile/profile'

const terms = () => import(/* webpackChunkName: "terms" */ '../page/terms/terms').catch(() => {})
const privacy = () =>
  import(/* webpackChunkName: "privacy" */ '../page/terms/privacy').catch(() => {})
const support = () =>
  import(/* webpackChunkName: "support" */ '../page/support/support').catch(() => {})

const DASHBOARD = 'DASHBOARD'
const CAMPAIGN = 'CAMPAIGN'
const DEPOSIT = 'DEPOSIT'
const PROFILE = 'PROFILE'

let firstMenus = [
  {
    t: 'Snapshot',
    i: 'ym_snapshot',
    children: false,
    key: DASHBOARD,
    permList: false,
    u: '/snapshot',
  },
  {
    t: 'Campaign',
    i: 'ym_offers',
    children: true,
    key: CAMPAIGN,
  },
  {
    t: 'Deposit',
    i: 'ym_offers',
    children: true,
    key: DEPOSIT,
  },
  {
    t: 'Profile',
    i: 'ym_snapshot',
    children: false,
    key: PROFILE,
    u: '/profile',
  },
]

let routes = [
  {
    // path: '/login',
    path: '/:lang/login',
    name: 'login',
    component: login,
    meta: {
      title:'Login｜App Store Optimization Platform｜ASOGrow',
      content: 'ASOGrow is a leading self-service App Store Optimization platform. Only takes 1 minute to create a campaign, and gain a speedy uplift in organic users.',
    },
  },
  {
    path: '/:lang/register',
    // path: '/register',
    name: 'register',
    component: register,
    meta: {
      title:'Sign Up｜App Store Optimization Platform｜ASOGrow',
      content: 'Sign up for the Android App Store Optimization Platform. Rank up your apps on Google Play and get more exposure to increase organic users. Get Users Now!',
    },
  },
  {
    // path: '/googleLogin',
    path: '/:lang/googleLogin',
    name: 'googleLogin',
    component: googleLogin,
  },
  {
    path: '/user-verify',
    name: 'user-verify',
    component: userVerify,
  },
  {
    path: '/token-invalid',
    name: 'token-invalid',
    component: tokenInvalid,
  },
  {
    path: '/terms',
    name: 'terms',
    component: terms,
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: privacy,
  },
  {
    path: '/',
    name: 'home',
    component: layout,
    redirect: { name: 'snapshot' },
    children: [
      {
        path: 'snapshot',
        name: 'snapshot',
        component: snapshot,
        meta: {
          title: 'Snapshot',
          permList: false,
        },
      },
      {
        path: 'campaign/create',
        name: 'campaign-create',
        component: campaignCreate,
        menu: CAMPAIGN,
        meta: {
          title: 'Create Campaign',
          langkey: 'menu3'
        },
      },
      {
        path: 'campaign/list',
        name: 'campaign-list',
        component: campaignList,
        menu: CAMPAIGN,
        meta: {
          title: 'My Campaign',
          langkey: 'menu4'
        },
      },
      {
        path: 'campaign/create-brush',
        name: 'campaign-create-brush',
        component: campaignCreateBrush,
        menu: CAMPAIGN,
        meta: {
          title: 'Top-ranking Task',
          langkey: 'menu10',
        },
      },
      {
        path: 'campaign/brush-list',
        name: 'campaign-brush-list',
        component: campaignBrushList,
        menu: CAMPAIGN,
        meta: {
          title: 'My Top-ranking Task',
          langkey: 'menu11',
        },
      },
      {
        path: 'deposit',
        name: 'deposit',
        component: deposit,
        menu: DEPOSIT,
        meta: {
          title: 'Deposit',
          langkey: 'menu5'
        },
      },
      {
        path: 'deposit/record',
        name: 'record',
        component: record,
        menu: DEPOSIT,
        meta: {
          title: 'Record',
          langkey: 'menu6'
        },
      },
      {
        path: 'profile',
        name: 'profile',
        component: profile,
        meta: {
          title: 'Account',
          langkey: 'menu7'
        },
      },
      {
        path: 'support',
        name: 'support',
        component: support,
        meta: {
          title: 'Support',
          langkey: 'menu9'
        },
      },
    ],
  },
]

let secondMenus = {}
for (let item of firstMenus) {
  if (item.children) {
    secondMenus[item.key] = [] // 二级菜单初始化
  }
}

for (let i in routes) {
  let route = routes[i]
  if (route.menu) {
    // 一级路由是否属于菜单项
    secondMenus[route.menu].push({
      t: route.meta.title,
      u: route.path,
    })
  } else if (route.children) {
    let parentPath = route.path === '/' ? '' : route.path
    let children = route.children
    for (let k in children) {
      // 遍历嵌套路由 看是否属于菜单项
      let child = children[k]
      let query_url = ''
      if (child.meta) {
        query_url = child.meta.query ? child.meta.query : ''
      }
      if (child.menu) {
        secondMenus[child.menu].push({
          t: child.meta.title,
          u: parentPath + '/' + child.path + query_url,
        })
      }
    }
  }
}

/**
 * 生成菜单对象
 * @permList 用户权限列表
 * @isSuperuser 是否管理员
 */
function generateMenu(permList, isSuperuser) {
  function hasPerm(perms) {
    return perms === false ? true : hasIntersect(perms, permList)
  }

  function resolveSecondMenus(menus) {
    let arr = []
    menus = secondMenus[menus]
    for (let menu of menus) {
      if (isSuperuser || hasPerm(menu.permList)) {
        arr.push({ t: menu.t, u: menu.u })
      }
    }
    return arr
  }

  function resolveFirstMenus(menus) {
    let arr = []
    for (let menu of menus) {
      if (menu.children) {
        // 一级目录存在子目录
        arr.push({ t: menu.t, i: menu.i, ul: resolveSecondMenus(menu.key) })
      } else if (isSuperuser || hasPerm(menu.permList)) {
        // 一级目录即为跳转项
        arr.push({ t: menu.t, i: menu.i, u: menu.u })
      }
    }
    return arr
  }

  let menu = resolveFirstMenus(firstMenus).filter(m => {
    return m.u || m.ul.length
  })
  return menu
}

export { generateMenu, routes }
